import { combineReducers } from "redux";

// Reducer imports
import customizationReducer from "./customizationReducer";
import tableDataSlice from "../views/Sales-Sections/salesReturn/slice/tableDataSlice";
import returnHeaderSlice from "../views/Sales-Sections/salesReturn/slice/returnHeaderSlice";
import discAndTaxSlice from "views/Sales-Sections/salesReturn/slice/discAndTaxSlice";
import posHeaderSlice from "views/Sales-Sections/salesPos/slice/posHeaderSlice";
import discAndTaxPosSlice from "views/Sales-Sections/salesPos/slice/discAndTaxPosSlice";
import tableDataPosSlice from "views/Sales-Sections/salesPos/slice/tableDataPosSlice";
import masterSlice from "views/Sales-Sections/salesPos/slice/masterSlice";
import commonSlice from "commonSlice/commonSlice";

//purchase slice
import puchaseHeaderSlice from "views/Purchase-Sections/purchase/slice/puchaseHeaderSlice";
import purchaseDiscAndTaxSlice from "views/Purchase-Sections/purchase/slice/purchaseDiscAndTaxSlice";
import purchaseTableDataSlice from "views/Purchase-Sections/purchase/slice/purchaseTableDataSlice";

//purchase slice
import puchaseImportHeaderSlice from "views/Purchase-Sections/purchase Import/slice/puchaseImportHeaderSlice";
import purchaseImportDiscAndTaxSlice from "views/Purchase-Sections/purchase Import/slice/purchaseImportDiscAndTaxSlice";
import purchaseImportTableDataSlice from "views/Purchase-Sections/purchase Import/slice/purchaseImportTableDataSlice";

//purchaseOrder slice
import puchaseOrdertHeaderSlice from "views/Purchase-Sections/purchaseOrder/slice/puchaseOrderHeaderSlice";
import purchaseOrderDiscAndTaxSlice from "views/Purchase-Sections/purchaseOrder/slice/purchaseOrderDiscAndTaxSlice";
import purchaseOrderTableDataSlice from "views/Purchase-Sections/purchaseOrder/slice/purchaseOrderTableDataSlice";

//purchaseReturn slice
import puchaseReturnHeaderSlice from "views/Purchase-Sections/purchaseReturn/slice/puchaseReturnHeaderSlice";
import purchaseReturnDiscAndTaxSlice from "views/Purchase-Sections/purchaseReturn/slice/purchaseReturnDiscAndTaxSlice";
import purchaseReturnTableDataSlice from "views/Purchase-Sections/purchaseReturn/slice/purchaseReturnTableDataSlice";

//products
import productDataSlice from "./apis";
import discAndTaxPosSliceB2C from "views/Sales-Sections/salesPosB2C/slice/discAndTaxPosSliceB2C";
import tableDataPosSliceB2C from "views/Sales-Sections/salesPosB2C/slice/tableDataPosSliceB2C";
import posHeaderSliceB2C from "views/Sales-Sections/salesPosB2C/slice/posHeaderSliceB2C";

//orderForm
import discAndTaxOrderFormSlice from "views/Sales-Sections/orderForm/slice/discAndTaxOrderFormSlice";
import tableDataOrderFormSlice from "views/Sales-Sections/orderForm/slice/tableDataOrderFormSlice";
import posHeaderOrderFormSlice from "views/Sales-Sections/orderForm/slice/posHeaderOrderFormSlice";

//salesReturnB2C
import discAndTaxReturnB2C from "views/Sales-Sections/SalesRetrunB2C/slice/discAndTaxSliceReturnB2C";
import tableDataReturnB2C from "views/Sales-Sections/SalesRetrunB2C/slice/tableDataSliceReturnB2C";
import returnHeaderB2C from "views/Sales-Sections/SalesRetrunB2C/slice/returnHeaderSliceB2C";

import posSlice from "views/pos/slice/posSlice";
import posItemsSlice from "views/pos/slice/posItemsSlice";
import posProductsSlice from "views/pos/slice/posProducts";
import privilegeSlice from "reduxs/slices/privilegeSlice";

// Combine reducers
const reducer = combineReducers({
  common: commonSlice,
  // products

  customization: customizationReducer,

  tableData: tableDataSlice,
  returnHeader: returnHeaderSlice,
  discAndTax: discAndTaxSlice,

  // sales pos reducers
  posHeader: posHeaderSlice,
  discAndTaxPos: discAndTaxPosSlice,
  tableDataPos: tableDataPosSlice,
  masterData: masterSlice,

  // sales pos reducers
  posHeaderB2C: posHeaderSliceB2C,
  discAndTaxPosB2C: discAndTaxPosSliceB2C,
  tableDataPosB2C: tableDataPosSliceB2C,

  //order form reducers
  posHeaderOrderForm: posHeaderOrderFormSlice,
  discAndTaxPosOrderForm: discAndTaxOrderFormSlice,
  tableDataOrderForm: tableDataOrderFormSlice,

  //purchase reducers
  purchaseHeader: puchaseHeaderSlice,
  purchaseDiscAndTax: purchaseDiscAndTaxSlice,
  purchaseTableData: purchaseTableDataSlice,

  //purchase import reducers
  puchaseImportHeader: puchaseImportHeaderSlice,
  purchaseImportDiscAndTax: purchaseImportDiscAndTaxSlice,
  purchaseImportTableData: purchaseImportTableDataSlice,

  //purchaseReturn reducers
  purchaseReturnHeader: puchaseReturnHeaderSlice,
  purchaseReturnDiscAndTax: purchaseReturnDiscAndTaxSlice,
  purchaseReturnTableData: purchaseReturnTableDataSlice,

  //purchaseOrder reducers
  puchaseOrderHeader: puchaseOrdertHeaderSlice,
  purchaseOrderDiscAndTax: purchaseOrderDiscAndTaxSlice,
  purchaseOrderTableData: purchaseOrderTableDataSlice,

  //allProduct
  ProductsData: productDataSlice,

  //saelesRetrunB2C
  discAndTaxReturnB2C: discAndTaxReturnB2C,
  tableDataReturnB2C: tableDataReturnB2C,
  returnHeaderB2C: returnHeaderB2C,

  // pos KOT

  posSlice: posSlice,
  posItems: posItemsSlice,
  posProducts:posProductsSlice,

  // user privilage

  privilageSlice:privilegeSlice
});

export default reducer;
